import { PLAN_PAYMENT_ERROR_KEY } from '../constants/planPayment.constants';

export const setPlanPaymentError = (message) => {
	sessionStorage.setItem(PLAN_PAYMENT_ERROR_KEY, message);
};
